<template>
  <div>
    <add-to-cart-modal
      v-if="showModal && type === 'add-to-cart'"
      :itemid="itemId"
      :customerid="customerid"
      :open="showModal"
      :show-prices="showPrices === 'True'"
    />

    <item-info-modal
      v-if="showModal && type === 'info'"
      :itemid="itemId"
      :customerid="customerid"
      :open="showModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import AddToCartModal from "./ItemModalAddToCart"
import ItemInfoModal from "./ItemModalInfo"

export default {
  name: "ItemModalOnLoad",
  components: {
    "add-to-cart-modal": AddToCartModal,
    "item-info-modal": ItemInfoModal,
  },
  props: {
    customerid: {
      type: String,
      required: false,
      default: function () {
        return null
      },
    },
    showPrices: {
      type: [String, Boolean],
      required: false,
      default: function () {
        return 'false'
      },
    },
  },
  computed: {
    ...mapGetters({
      itemId: "itemModal/itemId",
      showModal: "itemModal/showModal",
      type: "itemModal/type",
    }),
  },
  watch: {
    showInfoModal(val) {
      if (val === true) {
        this.showCartModal = false
      }
    },
    showCartModal(val) {
      if (val === true) {
        this.showInfoModal = false
      }
    },
  },
  created() {
    const hash = window.location.hash

    if (hash.includes("info-")) {
      const itemId = hash.split("info-")[1]
      this.$store.commit("itemModal/setItemId", itemId)
      this.$store.commit("itemModal/setType", "info")
      this.$store.commit("itemModal/showModal")
      return
    }

    if (hash.includes("add-to-cart-")) {
      const itemId = hash.split("add-to-cart-")[1]
      this.$store.commit("itemModal/setItemId", itemId)
      this.$store.commit("itemModal/setType", "add-to-cart")
      this.$store.commit("itemModal/showModal")
      return
    }
  },
}
</script>

<style></style>
